import React, { ChangeEvent, useState, useEffect } from 'react'
import logoImg from '../../assets/images/logoimg.png'
import logoImg1 from '../../assets/images/logoimg1.png'
import { message, Input, Modal } from 'antd'
import useGlobalModel from '../../model/globalModel'
import { useHistory } from 'react-router-dom'
import './Login.scss'
import { setToken } from '@/utils/constants'
import { loginServiceAuth2 } from './LoginServiceAuth2'
import { globalPrompt } from '@/components/message'
import { SmileTwoTone, ToolOutlined } from '@ant-design/icons'
import { debounce } from 'lodash'
import useNavModel from '@/model/navModel'

interface IgetIpType {
    cid: string
    cip: string
    cname: string
}

declare const window: Window & { returnCitySN?: IgetIpType }

export const Login = () => {
    const history = useHistory()
    const { user, setUser, setDealerNameData } = useGlobalModel()
    const { initNav } = useNavModel(() => [])

    const [state, setstate] = useState({
        userAccount: '',
        userPassword: '',
        token: '',
    })

    const [checkPwd, setCheckPwd] = useState<boolean>(() => {
        let userAccount = window.localStorage.getItem('userAccount')
        let userPassword = window.localStorage.getItem('userPassword')
        return !!(userAccount || userPassword)
    })

    const [loading, setLoading] = useState<boolean>(false)

    const onAccountChange = (e: ChangeEvent<HTMLInputElement>) => {
        setstate({ ...state, userAccount: e.target.value })
        checkPwd && window.localStorage.setItem('userAccount', e.target.value)
    }
    const onPasswordChange = (e: ChangeEvent<HTMLInputElement>) => {
        setstate({ ...state, userPassword: e.target.value })
        checkPwd && window.localStorage.setItem('userPassword', e.target.value)
    }

    const [IP, setIP] = useState<string>('')

    //回显记住账号密码
    useEffect(() => {
        let userAccount = window.localStorage.getItem('userAccount')
        let userPassword = window.localStorage.getItem('userPassword')

        if (userAccount || userPassword) {
            setstate({
                ...state,
                userAccount: userAccount ?? '',
                userPassword: userPassword ?? '',
            })
        }

        setIP(window.returnCitySN?.cip ?? '') //设置ip
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        user.token && history.push('/')
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user.token])
    const REACT_APP_ENV = process.env.REACT_APP_ENV as 'DEV' | 'TEST' | 'PROD' | 'STAGE'

    // 登录
    const doLogin = debounce(async () => {
        try {
            if (!state.userAccount) {
                message.warning('请输入账号')
                setLoading(false)
                return
            }
            if (!state.userPassword) {
                setLoading(false)
                message.warning('请输入密码')
                return
            }
            // debugger;
            let { retData, retMsg } = await loginServiceAuth2.Login(
                {
                    userCode: state.userAccount,
                    userPassword: state.userPassword,
                    // token: state.token,
                    // sourceApp: defaultMdCmParam.branch,
                },
                { headers: { REALIP: IP } },
            )
            let { retData: newToken }: any = await loginServiceAuth2.getToken()
            if (retData) {
                const setLogin = (dealerName: string) => {
                    setToken(newToken.token)
                    setUser({
                        deviceId: retData.deviceId,
                        userName: retData.mechanismName,
                        token: newToken.token,
                        shopCode: retData.createUserId,
                        createUser: dealerName || retData.name,
                        userType: retData.type,
                        userId: retData.userId,
                        accountName: retData.accountName,
                        dealerName: retData.dealerName || '',
                    })
                    globalPrompt('notification', {
                        type: 'success',
                        title: '登录成功',
                        duration: 3,
                        text: (
                            <p className="bold">
                                <span className="block">
                                    <SmileTwoTone /> {`您好!${retData.mechanismName ?? ''}`}
                                </span>
                                {REACT_APP_ENV === 'PROD' ? '欢迎使用云豪综合管理后台系统' : '欢迎使用云豪综合管理后台系统'}
                            </p>
                        ),
                    })
                }

                // window.location.reload()
                if (retData.dealerName) {
                    let setShopModal = Modal.confirm({
                        title: <span style={{ fontSize: '20px', fontWeight: 'bold' }}>请选择你的所辖车队</span>,
                        centered: true,
                        closable: true,
                        icon: <ToolOutlined />,
                        className: 'login-shop-modal',
                        content: (
                            <div className="login-shop-container">
                                {retData.dealerName.split(',').map((item: string, index: number) => (
                                    <span
                                        key={index}
                                        onClick={() => {
                                            setShopInfoOrUser(item)
                                            setDealerNameData(retData.dealerName.split(','))
                                        }}
                                    >
                                        {item}
                                    </span>
                                ))}
                            </div>
                        ),
                        onCancel: () => {
                            setUser({ ...user, shopId: '', shopName: '', shopCode: '', token: '' })
                            initNav()
                            history.push('/login')
                            setLoading(false)
                        },
                    })
                    const setShopInfoOrUser = (shop: string) => {
                        setLogin(shop)
                        setShopModal.destroy()
                    }
                } else {
                    setLogin('')
                }
            } else {
                message.error('登录失败：' + retMsg)
                setLoading(false)
            }
        } catch (error) {
            setLoading(false)
        }
    }, 800)

    //记住密码
    const checkout = (e: any) => {
        let checked = e.target.checked
        if (checked) {
            setCheckPwd(true)
            window.localStorage.setItem('userAccount', state.userAccount)
            window.localStorage.setItem('userPassword', state.userPassword)
        } else {
            setCheckPwd(false)
            window.localStorage.removeItem('userAccount')
            window.localStorage.removeItem('userPassword')
        }
    }
    return (
        <div className="container-login">
            <div className="login-warp">
                <div className="bg1">
                    <img src={REACT_APP_ENV === 'PROD' ? logoImg1 : logoImg1} alt="" className="login-logo" />
                    <p className="big-font">{REACT_APP_ENV === 'PROD' ? '云豪综合管理后台系统' : '云豪综合管理后台系统'}</p>
                    <p className="small-font">安全 | 高效 | 便捷</p>
                </div>

                <div className="input-box">
                    <div className="input-title">
                        <span>登录</span>
                    </div>
                    <div className="account form-line">
                        <p>账号</p>
                        <Input
                            type="text"
                            placeholder="请输入账号"
                            value={state.userAccount}
                            onChange={onAccountChange}
                            onKeyUp={(e) => {
                                if (e.key === 'Enter') {
                                    setLoading(true)
                                    !loading && doLogin()
                                }
                            }}
                        />
                    </div>
                    <div className="password form-line">
                        <p>密码</p>
                        <Input
                            type="password"
                            placeholder="请输入密码"
                            value={state.userPassword}
                            onChange={onPasswordChange}
                            onKeyUp={(e) => {
                                if (e.key === 'Enter') {
                                    setLoading(true)
                                    !loading && doLogin()
                                }
                            }}
                        />
                    </div>
                    <div className="login-input-three">
                        <span>
                            <input type="checkbox" defaultChecked={checkPwd} onClick={checkout} /> 记住密码
                        </span>
                    </div>
                    <p
                        className="login-but"
                        onClick={() => {
                            setLoading(true)
                            doLogin()
                        }}
                    >
                        立即登录
                    </p>

                    {loading && (
                        <div className="caseMarronFonce">
                            <div className="spinner"></div>
                            <div className="spinner-text">登录中。。。</div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}
